<template>
  <span
    v-if="visible"
    :class="{ 'text--strikethrough-primary': struckThrough }"
    class="price price--shopping-cart"
  >
    {{ humanizePriceFromCents(price) }}
  </span>
</template>

<script>
import { humanizePriceFromCents } from '@/lib/price';

export default {
  name: 'OrderTableItemPrice',
  props: {
    struckThrough: {
      type: Boolean,
      default: false,
    },
    price: {
      type: Number,
      default: 0,
    },
    showNullPrice: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    visible() {
      return !!(this.showNullPrice || this.price);
    },
  },
  methods: {
    humanizePriceFromCents,
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.price {
  text-align: center;
  @include font-size(21px, 27px);
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: baseline;

  &--shopping-cart {
    @include font-size-default();
    margin: 0;
    white-space: nowrap;
  }
}
</style>
